module.exports = __webpack_public_path__ + "img/stackslash-process-8-mobile.d8663f5b.jpg";